<template>
  <div class="card border-0">
    <div class="card-header bg-white border-0 p-0" :id="heading">
      <button class="btn btn-link w-100 text-custom-text text-left bg-white border-0 rounded-0 focus " style=""
              type="button"
              data-toggle='collapse' :data-target="'#'+ collapse"
              :aria-expanded="'false'"
              :aria-controls="collapse">
        {{ item.title }}
        <i class="ni ni-bold-down float-right text-main-color"></i>
      </button>
    </div>
    <div :id="collapse" class="collapse" :class="{ show: index === 0 && false }"
         :aria-labelledby="heading" :data-parent="'#'+accordionId">

      <div class="card-body text-custom-description d-grid grid-gap ">
        <div v-for="(item, index) in item_list" :key="index">
          <OrderDetailItem
              :title="item.title"
              :note="item.note"
              :amount="item.amount"
              :delivery_time="item.delivery_time"
              :price_data="item.price_data"
              :img="item.img"
              :tag_list="item.tag_list"
              :total_price="item.total_price"
              :price="item.price"
              :discount="item.discount"
              :combine_buy_discount="item.combine_buy_discount"
              :combine_buy_amount="item.combine_buy_amount"
              :exchange_rate="item.exchange_rate"
              :decrease="item.decrease"
              :stock="item.stock"
              :actual_stock="item.actual_stock"
              :history_list="item.history_list"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>


import OrderDetailItem from "@/views/components/elements/OrderDetailItem";

export default {
  name: "AccordionItem",
  components: {
    OrderDetailItem: OrderDetailItem,
  },
  props: {
    accordionId: {
      type: String,
      default: "",
    },
    item: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    item_list: {
      type: Array,
      default: () => [],
    },
    total_price: {
      type: Number,
      default: 0,
      text: "總價",
    },
    discount: {
      type: Number,
      default: 0,
    },
    combine_buy_discount: {
      type: Number,
      default: 0,
    },
    stock: {
      type: Number,
      default: 0,
      text: "總下單數量",
    },
    combine_buy_amount: {
      type: Number,
      default: 0,
      text: "湊箱數量"
    },
    exchange_rate: {
      type: Number,
      default: 0,
      text: "即時匯率"
    },
    decrease: {
      type: Number,
      default: 0,
      text: "減量"
    },
    actual_stock: {
      type: Number,
      default: 0,
      text: "實際到貨數量"
    },
    history_list: {
      type: Array,
      // default: [],
    }
  },
  data() {
    return {
      heading: "",
      collapse: ""
    }
  },
  created() {
    this.heading = 'heading-' + this.accordionId + '-' + this.index;
    this.collapse = 'collapse-' + this.accordionId + '-' + this.index;
  },


}
</script>

<style scoped>

button.bg-white:focus, button.bg-white:hover {
  background: white !important;
}


.grid-gap {
  grid-gap: 10px;
}

</style>
